__turbopack_context__.v({
  "Arrow": "CfYFeq_Arrow",
  "ArticleSection": "CfYFeq_ArticleSection",
  "ArticleWrapper": "CfYFeq_ArticleWrapper",
  "Column": "CfYFeq_Column",
  "ColumnLinks": "CfYFeq_ColumnLinks",
  "CompanyName": "CfYFeq_CompanyName",
  "Container": "CfYFeq_Container",
  "Content": "CfYFeq_Content",
  "Date": "CfYFeq_Date",
  "Footer": "CfYFeq_Footer",
  "FooterLogo": "CfYFeq_FooterLogo",
  "Icon": "CfYFeq_Icon",
  "ImageContainer": "CfYFeq_ImageContainer",
  "InfoWrapper": "CfYFeq_InfoWrapper",
  "Left": "CfYFeq_Left",
  "Link": "CfYFeq_Link",
  "LinkTitle": "CfYFeq_LinkTitle",
  "Links": "CfYFeq_Links",
  "Logo": "CfYFeq_Logo",
  "Marquee": "CfYFeq_Marquee",
  "MarqueeText": "CfYFeq_MarqueeText",
  "Right": "CfYFeq_Right",
  "RightMobile": "CfYFeq_RightMobile",
  "Root": "CfYFeq_Root",
  "TableOfContents": "CfYFeq_TableOfContents",
  "Title": "CfYFeq_Title",
  "skeleton-loading": "CfYFeq_skeleton-loading",
});
